import Dialog from '@/src/components/atom/Dialog';
import { CreditHistoryDto } from '@/src/models/CreditHistoryDto';
import DetailSection from '@/src/components/organism/DetailSection';
import dayjs from 'dayjs';
import { DetailSctionRenderer } from '@/src/components/organism/DetailSection/renderer';
import { UNIT_STRINGS } from '@/src/constants/unit';
import BadgeOptions from '@/src/components/molecule/BadgeOptions';

interface CreditDetailModalProps {
  open: boolean;
  onOpenChange: (value: boolean) => void;
  data?: CreditHistoryDto;
}

export default function CreditDetailModal({
  open: openProps,
  onOpenChange: onOpenChangeProps,
  data,
}: CreditDetailModalProps) {
  // event
  const handleCloseModal = () => {
    onOpenChangeProps(false);
  };

  return data ? (
    <Dialog
      open={openProps}
      onOpenChange={handleCloseModal}
      contentProps={{
        style: {
          width: 'calc(100vw - 24px)',
        },
        className: 'max-w-[697px]',
      }}
      title="크레딧 상세"
    >
      <div className="flex flex-col gap-6">
        <DetailSection
          className="bg-transparent p-0 !shadow-none"
          sectionTitle="회원 정보"
          data={data}
          contents={[
            [
              {
                key: ['customer', 'nick'],
                lable: '닉네임',
              },
              {
                key: ['customer', 'credit', 'currentCredit'],
                lable: '보유 크레딧',
                valueSetter: data =>
                  data.customer?.credit?.currentCredit
                    ? Number(
                        data.customer?.credit?.currentCredit,
                      ).toLocaleString()
                    : '0',
                render: DetailSctionRenderer.PREFIX_SUFFIX({
                  suffix: UNIT_STRINGS.CREDIT,
                }),
              },
            ],
          ]}
        />
        <DetailSection
          className="bg-transparent p-0 !shadow-none"
          sectionTitle="크레딧 정보"
          data={data}
          contents={[
            [
              {
                key: 'category',
                lable: '상위 카테고리',
              },
              {
                key: 'title',
                lable: '하위 카테고리',
                valueSetter: data => {
                  return (
                    data?.creditTemplate?.title ||
                    data?.subDescription ||
                    '직접 입력'
                  );
                },
              },
              {
                key: 'type',
                lable: '타입',
                render: value => (
                  <BadgeOptions
                    options={[
                      {
                        label: '적립',
                        value: '적립',
                        color: 'lightGreen',
                      },
                      {
                        label: '사용',
                        value: '사용',
                        color: 'lightPurple',
                      },
                      {
                        label: '차감',
                        value: '차감',
                        color: 'lightRed',
                      },
                      {
                        label: '소멸',
                        value: '소멸',
                        color: 'lightGray',
                      },
                    ]}
                    value={value}
                  />
                ),
              },
              {
                key: 'value',
                lable: '크레딧',
                valueSetter: data => {
                  return data.type === '적립'
                    ? `+${data.value.toLocaleString()}${UNIT_STRINGS.CREDIT}`
                    : `${data.value.toLocaleString()}${UNIT_STRINGS.CREDIT}`;
                },
              },
              {
                key: 'subDescription',
                lable: '사유',
                valueSetter: data => {
                  return data?.subDescription || '-';
                },
              },
              {
                key: 'createdAt',
                lable: '일시',
                valueSetter: data =>
                  dayjs(data.createdAt).format('YYYY-MM-DD HH:mm:ss'),
              },
              {
                key: 'adminName',
                lable: '관리자',
                valueSetter: data => data?.administrator?.name || '시스템',
              },
            ],
          ]}
        />
      </div>
    </Dialog>
  ) : null;
}
